import React from 'react';
import VerifyOTPForm from '../../components/VerifyOtp/VerifyOTPForm';
import AuthenticationLayout from '../../components/AuthenticationLayout/AuthenticationLayout';
import { useLocation } from 'react-router-dom';
import { VIA_EMAIL } from '../../lib/constants/globalConstant';

/*  Options object to determine the visibility and properties of the navigation button in the authentication layout. */
const options = {
  heading: "Verify Email Address",
  subHeading: "Enter One time password Here"
}

const VerifyOtpPage = () => {
  const { state } = useLocation();
  const { loginViaMethod: viaEmail } = state;

  return (
     /* Render the AuthenticationLayout component as a wrapper around the CreatePasswordForm. Pass the options object 
     to control the layout's property */
    <AuthenticationLayout options={{ ...options, heading: (viaEmail === VIA_EMAIL.PHONE_NUMBER) ? "Verify Phone Number" : options.heading }}>
      <VerifyOTPForm />
    </AuthenticationLayout>
  )
}

export default VerifyOtpPage